'use client';

import clsx from 'clsx';
import BasicLink from 'core/BasicLink';
import React, { useEffect, useState } from 'react';

import cn from './style.module.sass';

type CommonNavProps = {
    stepOne?: string;
    stepTwo?: string;
    stepThree?: string;
    className: string;
    link1: string | boolean;
    link2: string | boolean;
    link3?: string | boolean;
    seo?: boolean;
};

function CommonNav({
    stepOne,
    stepTwo,
    stepThree,
    className = '',
    link1,
    link2,
    link3,
    seo,
}: CommonNavProps) {
    const [path, setPath] = useState('');

    useEffect(() => {
        switch (stepThree?.toLowerCase()) {
            case 'маркетинг': {
                setPath('marketing');
                break;
            }

            case 'разработка': {
                setPath('development');
                break;
            }

            case 'продукты': {
                setPath('products');
                break;
            }
            default: {
                setPath('');
            }
        }
    }, []);

    return (
        <div className={clsx(cn.nav, cn[`${className}`])}>
            <BasicLink className={cn['nav__link']} href={link1 as string}>
                {stepOne}
            </BasicLink>{' '}
            /{' '}
            <BasicLink className={cn['nav__link']} href={link2 as string}>
                {stepTwo}
            </BasicLink>{' '}
            {link3 && (
                <>
                    /{' '}
                    <BasicLink className={cn['nav__link']} href={`${link2}/${path}`}>
                        {stepThree}
                    </BasicLink>
                </>
            )}
            {seo && <>/ {stepThree}</>}
        </div>
    );
}

export default CommonNav;
